import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { getTimeFormat } from '../../../service/NavPointsUtils';
import { CrewTypes } from '../../../service/constants';
import { sortSummaryPageCrew } from '../../../service/sort';
import { getTranslateText } from '../../../service/utils';
import { useStyles } from './useStyles';

export function SummaryCrewTable(props) {
    const { bufferCrew } = props;
    const classes = useStyles();
    const { t: translate } = useTranslation();

    return (
        <table className={classes.table}>
            <thead>
                <tr className={classes.header}>
                    <th className={classes.headerCell}>{translate('tables.id')}</th>
                    <th className={classes.headerCell}>{translate('tables.crew')}</th>
                    <th className={classes.headerCell}>{translate('tables.chair')}</th>
                    <th className={classes.headerCell}>{translate('tables.duty')}</th>
                    <th className={classes.headerCell}>{translate('tables.flight')}</th>
                    <th className={classes.headerCell}>{translate('tables.blockTime')}</th>
                </tr>
            </thead>
            <tbody>
                {bufferCrew && bufferCrew.length > 0 ? (
                    bufferCrew.sort(sortSummaryPageCrew).map((crew, index) => {
                        const { tableNumber = '', total = {} } = crew || {};
                        const { work, previousWork, block, flight, crewType, chairs = [] } = total;
                        const className = classnames(classes.info, crewType === CrewTypes.PCT_CABINSTAFF ? classes.cabin : classes.salon);

                        return (
                            <tr key={index}>
                                <td className={className}>{tableNumber}</td>
                                <td className={className}>{getTranslateText('fullName', crew)}</td>
                                <td className={className}>
                                    {Object.keys(chairs)
                                        .sort()
                                        .map(
                                            (key, i, arr) => `${getTranslateText('chair', chairs[key])}${i === arr.length - 1 ? '' : ', '}`
                                        )}
                                </td>
                                <td className={className}>
                                    {getTimeFormat(work + (previousWork || 0))}
                                    {previousWork ? <span className={classes.previousWork}>({getTimeFormat(work, true)})</span> : ''}
                                </td>
                                <td className={className}>{getTimeFormat(flight)}</td>
                                <td className={className}>{getTimeFormat(block)}</td>
                            </tr>
                        );
                    })
                ) : (
                    <tr className={classes.row}>
                        <td className={classes.noInfo}>{translate('messages.noCrewInfo')}</td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}
